import { checkEnrichedName } from 'bto-models/utils/string';
/**
 * Model for Match Outcomes
 */
export default class MatchesOutcomeModel {
  /**
   * class constructor method
   * @param data
   */
  constructor(data, homeTeam = "", guestTeam = "") {
    /**
     * Outcome ID
     * @type {number}
     */
    this.id = data.id;
    /**
     * Outcome Name
     * @type {string}
     */
    this.name = data.n && data.sbv ? `${data.n} (${data.sbv})` : data.n;
    /**
     * Original decimal value of outcome
     */
    this.originalDecimalOutcome = data.o;
    /**
     * Suspended outcome
     * @type {boolean}
     */
    this.suspended = data.su;
    /**
     * Column number (horizontal position)
     * @type {number}
     */
    this.column = data.col;
    /**
     * Order number (vertical position)
     * @type {number}
     */
    this.orderNo = data.ord;
    /**
     * Update class, possible values are 0, 1, -1
     */
    this.upDownClass = typeof data.ud !== "undefined" ? data.ud : "";
    /**
     * Identifier used for live matches
     * @type {string}
     */
    this.identifier = typeof data.i !== "undefined" && data.i !== null ? data.i : "";
    /**
     * Special bet value
     * @type {number}
     */
    this.sbv = data.sbv;
    /**
     * Enriched Outcome Name
     * @type {number}
     */
    this.enrichedOutcomeName = checkEnrichedName(data.eon, homeTeam, guestTeam, data.sbv);
  }
}
